import moment from "moment"

export function formatLastUpdated(value: string | null | undefined): string | null {
  if (!value) {
    return null
  }
  // Skill timestamps are midnight-UTC dates; format in UTC so the calendar day
  // doesn't shift for viewers west of UTC.
  const parsed = moment.utc(value, moment.ISO_8601, true)
  return parsed.isValid() ? parsed.format("MMM D, YYYY") : null
}
